"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var AppPaySystemWalletEditor = /** @class */ (function (_super) {
    __extends(AppPaySystemWalletEditor, _super);
    function AppPaySystemWalletEditor(props) {
        return _super.call(this, props) || this;
    }
    AppPaySystemWalletEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    payway_identity: _item.payway_identity,
                    wallet_pool_tag: _item.wallet_pool_tag,
                    description: _item.description,
                    is_locked: _item.is_locked,
                    wallet_crypto_currency_code: _item.wallet_crypto_currency_type_code,
                    wallet_crypto_currency_title: _item.wallet_crypto_currency_type_title,
                    app_currency_id: _item.wallet_app_currency_id,
                    app_currency_title: _item.wallet_app_currency_title,
                    transaction_ttl_minutes: _item.transaction_ttl_minutes,
                    blockchain_apikey: _item.blockchain_apikey
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Платежные направления", "Изменить платежное направление"]);
                });
            }
        }
        else {
            this.setState({
                payway_identity: "",
                wallet_pool_tag: "",
                description: "",
                is_locked: false,
                wallet_crypto_currency_code: 0,
                wallet_crypto_currency_title: "",
                app_currency_id: 0,
                app_currency_title: "",
                transaction_ttl_minutes: 0,
                blockchain_apikey: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Платежные направления", "Создать платежное направление"]);
            });
        }
        this.doReSetRules();
    };
    AppPaySystemWalletEditor.prototype.doReSetRules = function () {
        this.setState({
            wallet_pool_tag_rules: { isError: false },
            app_currency_rules: { isError: false },
            wallet_crypto_currency_rules: { isError: false },
            transaction_ttl_minutes_rules: { isError: false },
            blockchain_apikey_rules: { isError: false },
            payway_identity_rules: { isError: false }
        });
    };
    AppPaySystemWalletEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                payway_identity: this.state.payway_identity,
                wallet_pool_tag: this.state.wallet_pool_tag,
                transaction_ttl_minutes: this.state.transaction_ttl_minutes,
                is_locked: this.state.is_locked,
                description: this.state.description,
                wallet_app_currency_id: this.state.app_currency_id,
                blockchain_apikey: this.state.blockchain_apikey,
                wallet_crypto_currency_type_code: this.state.wallet_crypto_currency_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Платежное направление изменено!");
            });
        }
    };
    AppPaySystemWalletEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.wallet_pool_tag) || (this.state.wallet_pool_tag.length === 0)) {
            this.setState({
                wallet_pool_tag_rules: {
                    isError: true,
                    errorMessage: "Пул направления не заполнен!"
                }
            });
            return false;
        }
        if ((this.state.app_currency_id == 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({
                app_currency_rules: {
                    isError: true,
                    errorMessage: "Валюта не выбрана!"
                }
            });
            return false;
        }
        if ((this.state.wallet_crypto_currency_code == 0) || (this.state.wallet_crypto_currency_title.length === 0)) {
            this.setState({
                wallet_crypto_currency_rules: {
                    isError: true,
                    errorMessage: "Тип кошелька не выбран!"
                }
            });
            return false;
        }
        if (this.state.transaction_ttl_minutes <= 0) {
            this.setState({
                transaction_ttl_minutes_rules: {
                    isError: true,
                    errorMessage: "Время жизни транзакции указано некорректно!"
                }
            });
            return false;
        }
        if (this.state.blockchain_apikey.length === 0) {
            this.setState({
                blockchain_apikey_rules: {
                    isError: true,
                    errorMessage: "Апи ключ не заполнен!"
                }
            });
            return false;
        }
        return true;
    };
    AppPaySystemWalletEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                inner_pay_service_id: this.props.rootRecord.key,
                payway_identity: this.state.payway_identity,
                wallet_pool_tag: this.state.wallet_pool_tag,
                transaction_ttl_minutes: this.state.transaction_ttl_minutes,
                is_locked: this.state.is_locked,
                description: this.state.description,
                wallet_app_currency_id: this.state.app_currency_id,
                blockchain_apikey: this.state.blockchain_apikey,
                wallet_crypto_currency_type_code: this.state.wallet_crypto_currency_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Платежное направление добавлено");
            });
        }
    };
    AppPaySystemWalletEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AppPaySystemWalletEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить платежное направление";
        }
        else {
            return "Изменить платежное направление";
        }
    };
    AppPaySystemWalletEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600 },
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Идентификатор:",
                    placeholder: "Введите идентификатор платежного направления"
                }, value: this.state.payway_identity, onValueChanged: function (newVal) {
                    _this.setState({
                        payway_identity: newVal,
                        payway_identity_rules: { isError: false }
                    });
                }, required: true, rules: this.state.payway_identity_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Пул кошельков:",
                    placeholder: "Введите пул кошельков"
                }, value: this.state.wallet_pool_tag, onValueChanged: function (newVal) {
                    _this.setState({
                        wallet_pool_tag: newVal,
                        wallet_pool_tag_rules: { isError: false }
                    });
                }, required: true, rules: this.state.wallet_pool_tag_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Апи ключ",
                    placeholder: "Введите апи ключ блокчейна"
                }, value: this.state.blockchain_apikey, onValueChanged: function (newVal) {
                    _this.setState({
                        blockchain_apikey: newVal,
                        blockchain_apikey_rules: { isError: false }
                    });
                }, required: true, rules: this.state.blockchain_apikey_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Время жизни платежа, мин",
                    placeholder: "Введите время жизни платежа, минут"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.transaction_ttl_minutes
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        transaction_ttl_minutes: newVal,
                        transaction_ttl_minutes_rules: { isError: false }
                    });
                }, rules: this.state.transaction_ttl_minutes_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: {
                    caption: "Тип кошелька",
                    placeholder: "Выберите тип кошелька"
                }, value: { key: this.state.wallet_crypto_currency_code, value: this.state.wallet_crypto_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        wallet_crypto_currency_code: newVal.key,
                        wallet_crypto_currency_title: newVal.value,
                        wallet_crypto_currency_rules: { isError: false }
                    });
                }, items: this.props.availWalletCurrencyTypes, disabled: this.props.record != null, required: true, rules: this.state.wallet_crypto_currency_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: {
                    caption: "Валюта кошелька",
                    placeholder: "Выберите валюту кошелька"
                }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availAppCurrency, disabled: this.props.record != null, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Описание",
                    placeholder: "Введите описание"
                }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                    btnEdit: "Изменить",
                    btnNew: "Создать",
                    btnGoBack: "Назад"
                }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return AppPaySystemWalletEditor;
}(React.Component));
exports.default = AppPaySystemWalletEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem/ui/component/AppPaySystemPayWayEditor.tsx
// module id = 2572
// module chunks = 0